import isMobile from './is-mobile';

// add class where you want this util to run
const textOverflow = 'text-overflow';
const textOverflowing = `${textOverflow}--overflowing`;

const elements = [...document.querySelectorAll(`.${textOverflow}`)];
const showLines = 2.5;

let onMobile = isMobile();
let textCollapsed = false;
let windowWidth = window.innerWidth;

const isOverflowY = (item) => {
  return item.firstElementChild.scrollHeight > item.clientHeight;
};

const updateTextHeight = (text) => {
  textCollapsed = text.classList.contains(textOverflowing);
  const computedStyles = window.getComputedStyle(text);
  // calculate the maximum height for 3 lines of text
  const fontSize = parseFloat(computedStyles.fontSize);
  const lineHeight = parseFloat(computedStyles.lineHeight);
  const height = !isOverflowY(text)
    ? text.firstElementChild.scrollHeight
    : Math.round((fontSize + lineHeight) * showLines);

  // set the maximum height
  text.style.height = height && onMobile ? `${height}px` : '';
};

const toggleGradient = (element) => {
  // takes care of displaying/hiding a gradient
  element.classList.toggle(textOverflowing, isOverflowY(element));
};

const collapseText = (text) => {
  text.classList.add(textOverflowing);
  textCollapsed = true;
};

const expandOverflow = (element) => {
  element.addEventListener('click', ({ currentTarget }) => {
    // @todo check if we need to collapse text if clicked on again.
    textCollapsed = currentTarget.classList.contains(textOverflowing);

    if (textCollapsed) {
      currentTarget.classList.remove(textOverflowing);
      textCollapsed = false;
    }

    currentTarget.style.height = `${currentTarget.firstElementChild.scrollHeight}px`;
  });
};

const initTextOverflow = () => {
  elements.forEach((e) => {
    // set it as collapsed on mobile
    textCollapsed = onMobile;

    toggleGradient(e);

    if (onMobile) {
      collapseText(e);
      updateTextHeight(e);
    }
  });
};

(() => {
  if (elements.length) {
    initTextOverflow();

    // click event should be added only once
    elements.forEach((e) => expandOverflow(e));
  }
})();

if (elements.length) {
  window.addEventListener('resize', () => {
    if (window.innerWidth !== windowWidth) {
      // update the window width for next time
      windowWidth = window.innerWidth;
      // update the on mobile check
      onMobile = isMobile();

      elements.forEach((e) => {
        if (onMobile) {
          collapseText(e);
          toggleGradient(e);
        }

        updateTextHeight(e);
      });
    }
  });
}
